import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ambulance-view',
  templateUrl: './ambulance-view.component.html',
  styleUrls: ['./ambulance-view.component.scss']
})
export class AmbulanceViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
